module.exports = __webpack_public_path__ + "img/delete.dd90f086.png";